import {Component, EventEmitter, Input, Output} from '@angular/core';
export class PromptFooterComponent {

     modal: boolean = false;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'prompt-footer',
    template: `
        <div [class.modal-footer]="modal">
            <div [class.form-group]="!modal">
                <ng-content></ng-content>
            </div>
        </div>
    `
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'modal': [{ type: Input },],
};
}

function PromptFooterComponent_tsickle_Closure_declarations() {
/** @type {?} */
PromptFooterComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
PromptFooterComponent.ctorParameters;
/** @type {?} */
PromptFooterComponent.propDecorators;
/** @type {?} */
PromptFooterComponent.prototype.modal;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
